"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsHelpers_1 = require("../../../bridge/jsHelpers");
const jsHelpers_2 = require("@ledgerhq/coin-framework/bridge/jsHelpers");
const js_synchronisation_1 = require("../js-synchronisation");
const js_transaction_1 = require("../js-transaction");
const js_getTransactionStatus_1 = __importDefault(require("../js-getTransactionStatus"));
const js_signOperation_1 = __importDefault(require("../js-signOperation"));
const js_broadcast_1 = __importDefault(require("../js-broadcast"));
const js_estimateMaxSpendable_1 = __importDefault(require("../js-estimateMaxSpendable"));
const preload_1 = require("../preload");
const serialization_1 = require("../serialization");
const receive = (0, jsHelpers_1.makeAccountBridgeReceive)();
const currencyBridge = {
    preload: preload_1.preload,
    hydrate: preload_1.hydrate,
    getPreloadStrategy: preload_1.getPreloadStrategy,
    scanAccounts: js_synchronisation_1.scanAccounts,
};
const accountBridge = {
    estimateMaxSpendable: js_estimateMaxSpendable_1.default,
    createTransaction: js_transaction_1.createTransaction,
    updateTransaction: jsHelpers_2.defaultUpdateTransaction,
    getTransactionStatus: js_getTransactionStatus_1.default,
    prepareTransaction: js_transaction_1.prepareTransaction,
    sync: js_synchronisation_1.sync,
    receive,
    signOperation: js_signOperation_1.default,
    broadcast: js_broadcast_1.default,
    assignToAccountRaw: serialization_1.assignToAccountRaw,
    assignFromAccountRaw: serialization_1.assignFromAccountRaw,
};
exports.default = { currencyBridge, accountBridge };
//# sourceMappingURL=js.js.map